var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"container-fluid main-footer-go-ui"},[_c('span',[_vm._v("© Global Overview 2018- "+_vm._s(_vm.moment().year()))])])
}
var staticRenderFns = []

export { render, staticRenderFns }